<template>
	<div class="row contentblock">
		<div class="columns column12">
			<picture>
				<source :srcset="imageWebp" type="image/webp" />
				<source :srcset="image" />
				<img :src="image" :alt="imageAlt" loading="lazy" />
			</picture>
		</div>
		<div class="columns column6">
			<div class="contentblock-content">
				<h3>{{ header }}</h3>
				<div v-parse-links v-html="content" />
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	image: { type: String, default: '' },
	imageWebp: { type: String, default: '' },
	imageAlt: { type: String, default: '' },
	header: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblock {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	padding: 20px 40px;
	margin: 40px auto;
	width: 100%;
	position: relative;

	&::before {
		content: '';
		display: block;
		position: absolute;
		inset: 40px;
		z-index: 3;
		border: 1px solid #fff;
	}

	&:nth-child(odd) {
		flex-direction: row-reverse;
	}

	.button.no-fill,
	:deep(.button.no-fill) {
		border-color: #fff;
		color: #fff;

		&:hover {
			background: #fff;
			color: var(--cta-color-hover);
		}
	}

	.columns:first-child {
		padding: 0;
		position: absolute;
		inset: 0;
		z-index: 1;

		&::before {
			content: '';
			display: block;
			position: absolute;
			inset: 0;
			z-index: 2;
			background: rgb(0 0 0 / 40%);
		}
	}

	.column6 {
		position: relative;
		z-index: 4;
		color: #fff;
		margin: 150px 0;

		p,
		:deep(p),
		h2,
		:deep(h2),
		h3,
		:deep(h3) {
			color: #fff;
		}
	}

	img {
		object-fit: cover;
		width: 100%;
		height: 100%;
		position: relative;
		z-index: 1;
	}

	.contentblock-content {
		padding: 20px 50px;
	}
}

@media (max-width: 1080px) {
	.contentblock {
		padding: 20px 10px;

		&::before {
			inset: 10px;
		}

		.column6 {
			margin: 20px 0;
		}
	}
}

@media (max-width: 580px) {
	.contentblock {
		margin-bottom: 25px;

		.contentblock-content {
			padding: 0 20px;
		}
	}
}
</style>
